import React from "react";
import "./quiz-page.styles.scss";
import { useHistory } from "react-router-dom";
import CreateQuiz from "../../../assets/images/svg/undraw_add_content_d1tf.svg";
import ViewQuiz from "../../../assets/images/svg/undraw_selected_options_42hx.svg";

export default function QuizPage() {
    const history = useHistory();

    return (
        <div className="container">
            <div className="container__content">
                <div className="quiz-page">
                    <div className="title">
                        <h2 className="heading">Quiz</h2>
                    </div>
                    <div className="quiz-page__detail">
                        <div
                            className="quiz-page__detail__item cursor"
                            onClick={() => history.push(`/quiz/create`)}
                        >
                            <img
                                className="quiz-page__detail__item__image"
                                src={CreateQuiz}
                                alt="Create Quiz"
                            />
                            <h2>Create Quiz</h2>
                        </div>
                        <div
                            className="quiz-page__detail__item cursor"
                            onClick={() => history.push(`/quiz/view`)}
                        >
                            <img
                                className="quiz-page__detail__item__image"
                                src={ViewQuiz}
                                alt="Create Quiz"
                            />
                            <h2>View Quiz</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
